import * as React from "react"
import { Button, Flex, Stack, useDisclosure } from "@chakra-ui/react"

import { useCreateCommentMutation } from "lib/graphql"
import { useForm } from "lib/hooks/useForm"
import { useMe } from "lib/hooks/useMe"

import { Form } from "./Form"
import { LoginForm } from "./LoginForm"
import { Modal } from "./Modal"
import { Textarea } from "./Textarea"

interface ProjectCommentFormProps {
  projectId: string
  refetch: () => void
}

export const ProjectCommentsForm: React.FC<ProjectCommentFormProps> = ({ projectId, refetch }) => {
  const { me } = useMe()
  const modalProps = useDisclosure()
  const defaultValues = { message: "", isPrivate: false }
  const form = useForm({ defaultValues })
  const [createComment] = useCreateCommentMutation()

  const handleSubmit = (data: typeof defaultValues) => {
    form.handler(
      () => {
        return createComment({
          variables: { data: { ...data, projectId } },
        })
      },
      {
        onSuccess: (_, toast) => {
          form.reset()
          toast({ title: "Opmerking gemaakt" })
          refetch()
        },
      },
    )
  }
  return me ? (
    <Form onSubmit={handleSubmit} {...form}>
      <Stack spacing={4}>
        <Textarea name="message" label="" placeholder="Comment" isRequired />
        <Flex align="center" justify="space-between" w="100%" mt={2}>
          <Button
            bgColor="yellow.500"
            isDisabled={form.formState.isSubmitting}
            isLoading={form.formState.isSubmitting}
            type="submit"
            variant="solid"
            color="black"
          >
            Verstuur
          </Button>
        </Flex>
      </Stack>
    </Form>
  ) : (
    <>
      <Button w="100%" colorScheme="yellow" variant="outline" onClick={modalProps.onOpen}>
        Login om een comment achter te laten
      </Button>
      <Modal {...modalProps}>
        <LoginForm handleSubmit={modalProps.onClose} />
      </Modal>
    </>
  )
}
